import Vue from 'vue'

Vue.config.errorHandler = e => {
  console.error("errorHandler" ,e)
  Vue.prototype.$toasted.global.error(e.message)
}



// WEBPACK FOOTER //
// ./src/error.js